<template>
    <div>
     <div >
      <nav class="w-52 bg-white fixed left-0 top-0  min-h-screen  shadow-md">
      <div class="px-3 pt-8 logoclr">
         <img :src="'/imgs/tallyLogo4.png'" class="pb-2 " alt=""  aria-hidden="false"  >
         <hr>
      </div>
      <!-- <h6 class=" mt-1 pl-4 text-gray-400 font-bold">Menu</h6> -->
      <DxScrollView
        id="scrollview"
        ref="scrollViewWidget"
        :scroll-by-content="scrollByContent"
        :scroll-by-thumb="scrollByThumb"
        :show-scrollbar="showScrollbar"
        :bounce-enabled="pullDown"
        reach-bottom-text="Updating..."
        @pull-down="updateTopContent"
        @reach-bottom="updateBottomContent"
      >
      <ul class="flex flex-col items-center mt-2 ">
          <jet-responsive-nav-link   :active="route().current('tallyclinic.index')" :href="'/tallyclinic'" class=" w-full text-gray-400 ">
                    <i class="fas fa-th mr-3"></i>
                  <span class="link-label">Dashboard</span>
        </jet-responsive-nav-link>
      <!-- :href="'/integrate?is_license_valid='+is_valid_license+'&is_electron='+is_electron+'&license_from_database='+license_no" -->
    <jet-responsive-nav-link  :active="route().current('tc-integrates.index','tc')"  :href="'/tc/tc-integrates'" class=" w-full text-gray-400 ">
        <i class="fas fa-signal mr-3"></i>
          <span class="link-label">Integrate</span>
      </jet-responsive-nav-link>
      <!--  -->
          <jet-responsive-nav-link  :href="'/comingsoon'" class=" w-full text-gray-400 ">
                  <i class="fas fa-tools mr-3"></i>
                  <span class="link-label">Manage</span>
        </jet-responsive-nav-link>
      <!--  -->
         <jet-responsive-nav-link  :href="'/comingsoon'" class="block w-full text-gray-400 ">
                  <i class="fas fa-tasks mr-3"></i>
                  <span class="link-label">Print</span>
        </jet-responsive-nav-link>
      <!--  -->
          <jet-responsive-nav-link  :href="'/comingsoon'" class=" w-full text-gray-400 ">
                  <i class="fas fa-users mr-3"></i>
                  <span class="link-label">Report</span>
          </jet-responsive-nav-link>
      <!--  -->
         <jet-responsive-nav-link  :href="'/comingsoon'" class=" w-full text-gray-400">
                  <i class="fas fa-chart-line mr-3"></i>
                  <span class="link-label">Analyse</span>
        </jet-responsive-nav-link>
      <!--  -->
         <jet-responsive-nav-link   :href="'/comingsoon'" class=" w-full  text-gray-400 ">
                  <i class="fas fa-sync mr-3"></i>
                  <span class="link-label">Sync</span>
        </jet-responsive-nav-link>
      <!--  -->
           <jet-responsive-nav-link   :href="'/comingsoon'" class="w-full text-gray-400 ">
                  <i class="fas fa-comments mr-3"></i>
                  <span class="link-label">Tally-on-Cloud</span>
        </jet-responsive-nav-link>
      <!--  -->
          <jet-responsive-nav-link  :href="'/comingsoon'" class=" w-full text-gray-400 ">
                  <i class="fas fa-puzzle-piece mr-3"></i>
                  <span class="link-label">Add-Ons</span>
        </jet-responsive-nav-link>
      <!--  -->
         <jet-responsive-nav-link  :href="'/comingsoon'" class="w-full  text-gray-400 ">
                  <i class="fas fa-cubes mr-3"></i>
                  <span class="link-label">Modules</span>
        </jet-responsive-nav-link>
      <!--  -->
          <jet-responsive-nav-link :href="'/comingsoon'" class="w-full  text-gray-400 ">
                  <i class="fas fa-cogs mr-3"></i>
                  <span class="link-label">Services</span>
        </jet-responsive-nav-link>
      <!--  -->
           <jet-responsive-nav-link  :href="'/comingsoon'" class=" w-full text-gray-400 ">
                  <i class="fas fa-user-astronaut mr-3"></i>
                  <span class="link-label">Trainings</span>
        </jet-responsive-nav-link>
      <!--  -->
        <jet-responsive-nav-link  :href="'/comingsoon'" class=" w-full text-gray-400">
                  <i class="fas fa-handshake mr-3"></i>
                  <span class="link-label">Webinars</span>
        </jet-responsive-nav-link>
      <!--  -->
    </ul>
            <h6 class="text-gray-400  ml-4 font-bold">Account</h6>
              <ul>
                <!--  -->
              <jet-responsive-nav-link  :href="'/comingsoon'" class=" w-full text-gray-400 ">
                  <i class="fas fa-phone mr-3"></i>
                  <span class="link-label">Help & Support</span>
                </jet-responsive-nav-link>

            <!--  -->
                <jet-responsive-nav-link  :active="route().current('configurations.index')" :href="'/configurations'" class=" w-full  text-gray-400 ">
                  <i class="fas fa-cog mr-3"></i>
                  <span class="link-label">Settings</span>
                </jet-responsive-nav-link>
              <!--  -->
             <li class="h-8 w-full">
               <jet-responsive-nav-link   @click="logout" class=" w-full  text-gray-400 ">
                  <i class="fas fa-cog mr-3"></i>
                  <span class="link-label">Log Out</span>
                </jet-responsive-nav-link>
              
            </li>
            <!--  -->
              </ul>
      </DxScrollView>
      </nav>
     </div>
      <!-- header -->
       <header class=" ">
          <h2 class="font-bold mt-6 "><slot name="headerTitle" v-if="$slots.headerTitle"></slot></h2>
        <ul class="nav-list mt-6">
        </ul>
      </header>
     <!-- NavBar -->
      <nav-bar>
          <slot name="headerNav" v-if="$slots.headerNav"></slot>
      </nav-bar>
      <div class="main-content">
           <slot></slot>
      </div>
    </div>
</template>
<script>
import { DxScrollView } from 'devextreme-vue/scroll-view';
import JetResponsiveNavLink from "@/Jetstream/ResponsiveNavLink.vue";
import JetNavLink from '@/Jetstream/NavLink.vue';
import NavBar from './TallyClinicTopNavbar.vue';
 import JetDropdownLink from '@/Jetstream/DropdownLink.vue'
// import {isElectron,checkTallyIsOpenElectron} from"@/Pages/TallyClinic/Utils/js/utils/utils.js";
export default {
  components:{
    JetNavLink,
    JetDropdownLink,
    NavBar,
    JetResponsiveNavLink,
    DxScrollView
  },
  data:function(){
    return{
      tally_open_status:'false',
      pullDown: false,
      showScrollbar: 'onScroll',
      scrollByContent: true,
      scrollByThumb: true,
    }
  },
  methods:{
        checkTallyStatus(){
            var _this = this;
            checkTallyIsOpenElectron(_this);
        },
        logout(){
            this.$inertia.post(route('logout'));
        },
        reload_in_electron(){
            //check if tally is open 
            if(isElectron()){
                window.api.send('refresh_page'); 
                window.api.receive("refresh_page-reply", (tally_response) => {
                })
            }
        }
  },
  mounted(){
        $('li').on('click',function(){
        var a_links = $(this).find('a');
        $('a').removeClass('active');
        a_links.addClass('active');
        var _this = this;
        checkTallyIsOpenElectron(_this);
        
        })
},
}
</script>
<style >
/* body {
  min-height: 100vh;
  background-color: #f3f4f6;
  padding: 0px;
} */
a.active {
  color:#10b981;
  font-weight: 300;
   /* background: #abffe3; */
}
 a .link.active::after {
  content: "";
  height: 100%;
  position: absolute;
  left: 205px;
  top: 0;
  width: 4px;
  background-color: #10b981;
}
a:hover{
  /* background-color: #10b981; */
  color: #10b981;
  text-decoration: none;
}
nav{
  transition:all .2s;
  /* border: 2px solid rgb(233, 233, 233); */
}

nav.expanded .link-label {
  display: none;
}
nav.expanded {
  width: 66px;
}
nav.expanded ul li{
  align-items: center;
  justify-content: center;
}
nav.expanded ul li a{
  align-items: center;
  justify-content: center;
}
nav.expanded ul li a svg{
 margin: 0;
}

/* header page */
header{
  /* overflow: hidden; */
  position: fixed; /* Set the navbar to fixed position */
  top: 0; 
  padding:4px 43px;
  width: 86%;
  display:flex;
  justify-content:space-between;
  background:white;
  /* border: 1px solid gray; */
 	margin-left: 210px;
   z-index: 1;
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  header{
width: 76%;
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  header{
width: 82%;
  }
}

@media only screen and (min-width: 1280px) {
  header{
width: 86%;
  }
}

.nav-list{
  display:flex;
  flex-flow : row-reverse wrap;
  justify-content: space-around;
  align-items: center;
}
.nav-list li{
  display:inline-block;
  padding:10px;
  margin: 4px;
  width:auto;
  border-radius: 10px;
}
.nav-list a{
  color: rgb(150, 145, 145);
}
.logoclr{
  background-color: #07528E;
}
#scrollview {
  height: 80%;
  position: absolute;
  top: 130px;
  bottom: 10px;
  padding: 1px;
  width: 100%;
}
</style>